import React from 'react';
import {Helmet} from 'react-helmet-async';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const {FiPhone, FiMail, FiMapPin, FiClock, FiCalendar} = FiIcons;

const Contatti = () => {
  return (
    <>
      <Helmet>
        <title>Contatti - Realizzazione Siti Web Napoli | Preventivo Gratuito</title>
        <meta name="description" content="Contatta la nostra web agency a Napoli. Preventivo gratuito in 24h per siti web,e-commerce,SEO e marketing digitale. Chiamaci: +39 350 070 3118" />
        <meta name="keywords" content="contatti web agency napoli,preventivo sito web napoli,consulenza gratuita napoli" />
        <link rel="canonical" href="https://realizzazionesitiwebnapoli.com/contatti" />
      </Helmet>

      {/* Hero Section - Velo scuro al 40% */}
      <section className="relative min-h-[60vh] bg-napoli-gradient text-white overflow-hidden flex items-center justify-center">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=1920&auto=format&fit=crop')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="relative container mx-auto px-4 py-20 text-center z-10">
          <div className="max-w-4xl mx-auto mt-12 md:mt-0">
            <motion.h1 
              initial={{opacity: 0, y: 30}} 
              animate={{opacity: 1, y: 0}} 
              className="text-4xl lg:text-5xl font-poppins font-bold mb-6 text-white drop-shadow-lg"
            >
              Contattaci per un progetto digitale
            </motion.h1>
            <motion.p 
              initial={{opacity: 0, y: 30}} 
              animate={{opacity: 1, y: 0}} 
              transition={{delay: 0.2}}
              className="text-xl mb-8 text-white leading-relaxed drop-shadow-md"
            >
              Siamo qui per aiutarti a far crescere il tuo business online. Contattaci con il metodo che preferisci.
            </motion.p>
            <motion.div 
              initial={{opacity: 0, y: 30}} 
              animate={{opacity: 1, y: 0}} 
              transition={{delay: 0.4}}
              className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8"
            >
              <a 
                href="https://tidycal.com/sitiwebstudio/consulenza-siti-web-napoli" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-napoli-accent hover:bg-yellow-400 text-napoli-blu font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-napoli-accent focus:ring-opacity-50 shadow-lg hover:shadow-xl text-lg"
              >
                <SafeIcon icon={FiCalendar} className="w-5 h-5 mr-2 inline" />
                Prenota una call gratuita
              </a>
              <a 
                href="https://wa.me/393500703118?text=Ciao,%20vorrei%20informazioni%20sui%20vostri%20servizi" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-50 shadow-lg hover:shadow-xl text-lg"
              >
                <span className="mr-2">💬</span>
                Chatta su WhatsApp
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-6">Informazioni di contatto</h2>
              <p className="text-xl text-napoli-blu font-medium">
                Siamo qui per aiutarti a far crescere il tuo business online. Contattaci con il metodo che preferisci.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-napoli-light rounded-xl p-8 shadow-napoli-lg">
                <h3 className="text-2xl font-poppins font-bold text-napoli-blu mb-6">Contatti diretti</h3>
                
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-napoli-accent rounded-lg flex items-center justify-center flex-shrink-0">
                      <SafeIcon icon={FiPhone} className="w-6 h-6 text-napoli-blu" />
                    </div>
                    <div>
                      <h4 className="font-bold text-napoli-blu mb-1">Telefono</h4>
                      <a href="tel:+393500703118" className="text-napoli-blu hover:text-napoli-azzurro font-semibold">
                        +39 350 070 3118
                      </a>
                      <p className="text-sm text-napoli-blu">Chiamate e WhatsApp</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-napoli-accent rounded-lg flex items-center justify-center flex-shrink-0">
                      <SafeIcon icon={FiMail} className="w-6 h-6 text-napoli-blu" />
                    </div>
                    <div>
                      <h4 className="font-bold text-napoli-blu mb-1">Email</h4>
                      <a href="mailto:info@realizzazionesitiwebnapoli.com" className="text-napoli-blu hover:text-napoli-azzurro font-semibold">
                        info@realizzazionesitiwebnapoli.com
                      </a>
                      <p className="text-sm text-napoli-blu">Risposta entro 24h</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-napoli-accent rounded-lg flex items-center justify-center flex-shrink-0">
                      <SafeIcon icon={FiMapPin} className="w-6 h-6 text-napoli-blu" />
                    </div>
                    <div>
                      <h4 className="font-bold text-napoli-blu mb-1">Indirizzo</h4>
                      <p className="text-napoli-blu font-semibold">
                        Via Toledo 123<br />
                        80134 Napoli (NA)
                      </p>
                      <p className="text-sm text-napoli-blu">Zona centro storico</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-napoli-accent rounded-lg flex items-center justify-center flex-shrink-0">
                      <SafeIcon icon={FiClock} className="w-6 h-6 text-napoli-blu" />
                    </div>
                    <div>
                      <h4 className="font-bold text-napoli-blu mb-1">Orari</h4>
                      <p className="text-napoli-blu font-semibold">
                        Lunedì - Venerdì: 9:00 - 18:00<br />
                        Sabato: 9:00 - 13:00
                      </p>
                      <p className="text-sm text-napoli-blu">Domenica chiuso</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="space-y-8">
                {/* WhatsApp CTA */}
                <div className="bg-green-50 border-2 border-green-200 rounded-lg p-6">
                  <h3 className="font-bold text-green-800 mb-2">Hai fretta?</h3>
                  <p className="text-green-700 mb-4 font-medium">Scrivici su WhatsApp per una risposta immediata</p>
                  <a 
                    href="https://wa.me/393500703118?text=Ciao,%20vorrei%20informazioni%20sui%20vostri%20servizi" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-bold transition-colors"
                  >
                    <span className="mr-2">💬</span>
                    Chatta su WhatsApp
                  </a>
                </div>
                
                {/* Prenotazione Call */}
                <div className="bg-napoli-light border-2 border-napoli-azzurro rounded-lg p-6">
                  <h3 className="font-bold text-napoli-blu mb-2">Vuoi parlare con un consulente?</h3>
                  <p className="text-napoli-blu mb-4 font-medium">Prenota una call gratuita per discutere il tuo progetto</p>
                  <a 
                    href="https://tidycal.com/sitiwebstudio/consulenza-siti-web-napoli" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-napoli-azzurro hover:bg-blue-500 text-white px-6 py-3 rounded-lg font-bold transition-colors"
                  >
                    <SafeIcon icon={FiCalendar} className="w-5 h-5 mr-2" />
                    Prenota una call
                  </a>
                </div>
                
                {/* Email Diretta */}
                <div className="bg-yellow-50 border-2 border-yellow-200 rounded-lg p-6">
                  <h3 className="font-bold text-yellow-800 mb-2">Preferisci l'email?</h3>
                  <p className="text-yellow-700 mb-4 font-medium">Scrivici direttamente per un preventivo dettagliato</p>
                  <a 
                    href="mailto:info@realizzazionesitiwebnapoli.com?subject=Richiesta%20preventivo&body=Ciao,%0D%0AVorrei%20richiedere%20un%20preventivo%20per%20un%20progetto%20di%20[specificare%20il%20servizio%20richiesto].%0D%0APotete%20contattarmi%20al%20seguente%20recapito:%0D%0A%0D%0AGrazie!" 
                    className="inline-flex items-center bg-yellow-400 hover:bg-yellow-500 text-napoli-blu px-6 py-3 rounded-lg font-bold transition-colors"
                  >
                    <SafeIcon icon={FiMail} className="w-5 h-5 mr-2" />
                    Scrivi un'email
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contatti;